import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { AppService } from '../app.service';

export const languageResolver: ResolveFn<unknown> = () => {
  const appService = inject(AppService);

  return appService.getCodeListsByGroup(
    "TRAINING_LANGUAGE"
  );
};
